<template>
    <div class="container">
        <a class="hyper-section" name="main3"></a>

  <TestimonialCard v-for="testimonial in testimonials" :key="testimonial.id" v-bind:testimonial="testimonial"/>
    </div>
</template>

<script>
import TestimonialCard from './TestimonialCard'
export default {
    components:{
        TestimonialCard
    },
    data: function(){
        return {
            testimonials:[
                {
                    id:1,
                    grade:5,
                    title: "Garderobsystem",
                    content:"Hany är en suverän snickare och målare, han är en duktig på att projektera och arbeta. Är påhittig och löser problemen på plats. Hany byggde ett jättefint garderobsystem hos mig. Jag fick många offerter och idéer av tidigare snickare men jag kände mig mest bekväm med Hanys system som blev ett topp resultat och billigare än de andra offerterna. Jag skulle vilja ge 5 av 5 i betyg 👍🏼 lycka till med framtida projekt Hany!",
                    customer:"Marwa",
                    date:new Date("2021-03-01")
                },
                {
                    id:2,
                    grade:5,
                    title: "Målning, parkett samt snickeri...",
                    content:"Jag har anlitat Magdalena Bygg för att måla, lägga parkett och lite snickeri arbete i vårat radhus och det gick mycket bra och smidigt och vi är nöjda med arbetet. Jag kan ge honom en 5.",
                    customer:"Samir",
                    date:new Date("2021-02-25")
                },
               
               { 
                id:3,
               grade:5,
               title: "Superduktig!",
               content:"Hany är superduktig och har gjort ett väldigt bra och noggrann jobb hos mig och jag är mycket nöjd med allt han har gjort, jag skulle rekommendera honom.", 
               customer:"Mugdad",
               date: new Date  ("2021-02-24")

               },

               {
              id:4,
               grade:4,
               title: "Byta fasad och bygga en altan + fasadmålning",
               content:"Jag anlitade Hany till att byta fasad och bygga en altan. Någon månad senare anlitade vi honom till att måla hela huset. Jag är jätte nöjd över hans båda  insatser. Hany jobbar på jättebra och jag har rekommenderat honom till flera vänner. Hany är superduktig och har gjort ett väldigt bra och noggrann jobb hos mig och jag är mycket nöjd med allt han har gjort, jag skulle rekommendera honom.", 
               customer:"Akiliu",
               date: new Date  ("2021-02-24")

               },

               {
              id:5,
               grade:4,
               title: "Renovera min lägenhet.",
               content:"Hany jobbade hos mig att renovera min lägenhet. Han lade Golv,  målningsarbete, (tagit bort tapeter och lagt Golv). Han jobbar bra. Jag är nöjd med den. Jag ge honom 4 poäng.", 
               customer:"Yonas",
               date: new Date  ("2021-02-24")

               },


            ]
        }
    }
}
</script>

<style>

</style>